import { u as useTheme, d as defaultTheme, T as THEME_ID } from './styled-722a6242.js';
import { g as getThemeProps } from './getThemeProps-582952b7.js';

function useThemeProps$1({
  props,
  name,
  defaultTheme,
  themeId
}) {
  let theme = useTheme(defaultTheme);
  if (themeId) {
    theme = theme[themeId] || theme;
  }
  const mergedProps = getThemeProps({
    theme,
    name,
    props
  });
  return mergedProps;
}

function useThemeProps({
  props,
  name
}) {
  return useThemeProps$1({
    props,
    name,
    defaultTheme,
    themeId: THEME_ID
  });
}

export { useThemeProps$1 as a, useThemeProps as u };
//# sourceMappingURL=useThemeProps-624634df.js.map
